import { useQuery } from 'react-query'
import { useGlobalLoading } from '../contexts/LoadingContext'
import { api } from '../servicesGlobais/api'

interface UseDomainDataOptions {
  staleTime?: number
  cacheTime?: number
  enabled?: boolean
}

/**
 * Hook genérico para buscar dados de domínio (tipos, status, prioridades, pessoas, etc.)
 */
export function useDomainData<T>(
  queryKey: string | string[],
  endpoint: string,
  options: UseDomainDataOptions = {}
) {
  const { stopLoading } = useGlobalLoading()
  const { staleTime = 5 * 60 * 1000, cacheTime, enabled = true } = options

  return useQuery<T[]>(
    queryKey,
    () => api.get<T[]>(endpoint),
    {
      staleTime,
      cacheTime,
      enabled,
      onSuccess: () => stopLoading(),
      onError: () => stopLoading(),
    }
  )
}

/**
 * Hook para buscar tipos de projeto
 */
export function useTiposProjeto() {
  return useDomainData('tipos-projeto', '/TipoProjeto')
}

/**
 * Hook para buscar status de projeto
 */
export function useStatusProjeto() {
  return useDomainData('status-projeto', '/StatusProjeto')
}

/**
 * Hook para buscar prioridades
 */
export function usePrioridades() {
  return useDomainData('prioridades', '/Prioridade')
}

/**
 * Hook para buscar solicitantes (cargoCodigo=1)
 */
export function useSolicitantes() {
  return useDomainData('solicitantes', '/Pessoa?cargoCodigo=1')
}

/**
 * Hook para buscar analistas SMN (cargoCodigo=2)
 */
export function useAnalistasSMN() {
  return useDomainData('analistas-smn', '/Pessoa?cargoCodigo=2')
}

/**
 * Hook para buscar analistas DDP (cargoCodigo=3)
 */
export function useAnalistasDDP() {
  return useDomainData('analistas-ddp', '/Pessoa?cargoCodigo=3')
}

/**
 * Hook para buscar desenvolvedores (cargoCodigo=4)
 */
export function useDesenvolvedores() {
  return useDomainData('desenvolvedores', '/Pessoa?cargoCodigo=4')
}
